class NewsletterStrip {
    constructor(container) {
        this.strip = container;
        this.closeBtn = this.strip.querySelector('.sticky-strip__close');
        this.hero = document.querySelector('.hero-banner');

        if (!this.hero) return;

        this.heroBottom = this.hero.offsetTop + this.hero.offsetHeight;

        this.bindEvents();
        this.handleScroll();
    }

    bindEvents() {
        if (this.closeBtn) {
            this.closeBtn.addEventListener('click', () => {
                this.strip.style.display = 'none';
            });
        }

        window.addEventListener('scroll', this.handleScroll.bind(this));
    }

    handleScroll() {
        const scrollY = window.scrollY || window.pageYOffset;

        if (scrollY > this.heroBottom) {
            this.strip.classList.add('is-visible');
        }
    }
}

function initNewsletterStrip() {
    const stripEl = document.querySelector('.sticky-strip');
    if (stripEl) {
        new NewsletterStrip(stripEl);
    }
}

document.addEventListener('DOMContentLoaded', initNewsletterStrip);